var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-results"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"item my-5"},[_c('product-item',{attrs:{"item":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }